import { render, staticRenderFns } from "./hot-news-item.vue?vue&type=template&id=33b65975&scoped=true&"
import script from "./hot-news-item.vue?vue&type=script&lang=ts&"
export * from "./hot-news-item.vue?vue&type=script&lang=ts&"
import style0 from "./hot-news-item.vue?vue&type=style&index=0&id=33b65975&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b65975",
  null
  
)

export default component.exports